<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoInserir">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoInserir">
			<form #f="ngForm" name="form" novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="data">Data da Saída</label>
							<p-calendar [showIcon]="true" [showOnFocus]="false" dateFormat="dd/mm/yy"
								[showButtonBar]="true" name="data" ngModel #data="ngModel" [required]="true"
								[(ngModel)]="dataSelecionada">
							</p-calendar>
						</div>
						<div class="field col-12 md:col-4">
							<label>Produto</label>
							<div class="p-inputgroup">
								<input type="text" pInputText ngModel name="descricaoProduto"
									#descricaoProduto="ngModel" [(ngModel)]="descricaoProdutoSelecionado" readonly />
								<button type="button" pButton pRipple
									[icon]="produtoSelecionado ? 'pi pi-pencil' : 'pi pi-plus'" pTooltip="Selecione"
									class="p-button-success" style="box-shadow: none;" (click)="abrirDialogProduto()">
								</button>
							</div>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="quantidade">Quantidade</label>
							<input type="text" pInputText name="quantidade" ngModel #quantidade="ngModel"
								[(ngModel)]="quantidadeInformada" required />
						</div>
						<div class="field col-12 md:col-4">
							<label>Atendente</label>
							<div class="p-inputgroup">
								<input type="text" pInputText ngModel name="nomeAtendente" #nomeAtendente="ngModel"
									[(ngModel)]="nomeAtendenteSelecionado" readonly />
								<button type="button" pButton pRipple
									[icon]="atendenteSelecionado ? 'pi pi-pencil' : 'pi pi-plus'" pTooltip="Selecione"
									class="p-button-success" style="box-shadow: none;" (click)="abrirDialogAtendente()">
								</button>
							</div>
						</div>
					</div>
					<div class="p-fluid p-formgrid grid justify-content-between mt-3">
						<div class="col-12 md:col-2">
							<button *ngIf="!progressoRequisicao else exibirBotaoFalso"
								type="button" pButton icon="pi pi-check" label="Salvar" (click)="salvar()"
								class="p-button-outlined p-button-success md:w-9rem"
								[disabled]="!f.valid || !produtoSelecionado || !atendenteSelecionado || quantidadeInformada <= 0">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="button" pButton icon="pi pi-spin pi-spinner" label="salvar"
								class="p-button-outlined p-button-success md:w-9rem" [disabled]="true"></button>
							</ng-template>
						</div>
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/saida-estoque"></button>
						</div>
					</div>
				</div>
			</form>
			<p-dialog header="Escolher Produto" [(visible)]="exibirDialogProduto" [modal]="true" [draggable]="false"
				[resizable]="false" [closable]="true">
				<div class="flex justify-content-center" *ngIf="exibirSpinnerDialog">
					<p-progressSpinner></p-progressSpinner>
				</div>
				<p-table #tbItensDialog [value]="listaProdutosDialog" dataKey="id"
					[rows]="itensProdutosPaginados ? itensProdutosPaginados.size : 0" [loading]="loadingTableItens"
					[rowHover]="true" [paginator]="true" (onPage)="onPageChangeProdutos($event)"
					[totalRecords]="itensProdutosPaginados ? itensProdutosPaginados.totalElements : 0" [lazy]="true"
					[showCurrentPageReport]="true" responsiveLayout="scroll" styleClass=" p-datatable-sm"
					currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
					*ngIf="!exibirSpinnerDialog">
					<ng-template pTemplate="caption">
						<div class="flex justify-content-end flex-column sm:flex-row">
							<span class="p-input-icon-left">
								<i class="pi pi-search"></i>
								<input pInputText type="text" #filter (input)="buscarDialogItens($event)"
									placeholder="Buscar" class="w-full" />
							</span>
							<span class="ml-2">
								<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
									pTooltip="Limpar Filtros" (click)="limparDialogItens()"></button>
							</span>
						</div>
					</ng-template>
					<ng-template pTemplate="header">
						<tr>
							<th pSortableColumn="codigo">
								<div>
									Código
								</div>
							</th>
							<th pSortableColumn="descricao">
								<div>
									Descrição
								</div>
							</th>
							<th>
								<div>
									Estoque atual
								</div>
							</th>

							<th style="text-align: center;">
								<div>
									Selecionar
								</div>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-item let-i="rowIndex">
						<tr>
							<td>
								<label>{{ item.codigo }}</label>
							</td>
							<td>
								<label>{{ item.descricao }}</label>
							</td>
							<td>
								<label>{{ item.estoqueAtual }} {{ item.descricaoUnidadeMedida }}</label>
							</td>

							<td style="text-align: center;">
								<button pButton pRipple pTooltip="Adicionar" type="button" icon="pi pi-check"
									class="p-button-success" (click)="selecionarItem(item)">
								</button>
							</td>
						</tr>
					</ng-template>
				</p-table>
			</p-dialog>
			<p-dialog header="Selecionar Atendente" [(visible)]="exibirDialogAtendente" [modal]="true"
				[draggable]="false" [resizable]="false" [closable]="true" [style]="{width: '40rem'}">
				<div class="flex justify-content-center" *ngIf="exibirSpinnerDialogAtendente">
					<p-progressSpinner></p-progressSpinner>
				</div>
				<p-table #tbAtendentes [value]="listaAtendentes" dataKey="id" [rows]="10" [rowHover]="true"
					styleClass="p-datatable-gridlines" [paginator]="true" responsiveLayout="scroll"
					styleClass=" p-datatable-sm" [globalFilterFields]="['nomeProfissional']"
					*ngIf="!exibirSpinnerDialogAtendente">
					<ng-template pTemplate="caption">
						<div class="flex justify-content-end flex-column sm:flex-row">
							<span class="p-input-icon-left">
								<i class="pi pi-search"></i>
								<input pInputText type="text" #filter (input)="buscar(tbAtendentes, $event)"
									placeholder="Buscar" class="w-full" />
							</span>
							<span class="ml-2">
								<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
									pTooltip="Limpar Filtros" (click)="limpar(tbAtendentes)"></button>
							</span>
						</div>
					</ng-template>
					<ng-template pTemplate="header">
						<tr>
							<th pSortableColumn="nomeProfissional">
								Nome
								<p-sortIcon field="nomeProfissional">
							</p-sortIcon>
							</th>

							<th style="text-align: end;">
								<div>
									Selecionar
								</div>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-item let-i="rowIndex">
						<tr>
							<td>
								<label>{{ item.nomeProfissional }}</label>
							</td>

							<td style="text-align: end;">
								<button pButton pRipple pTooltip="Adicionar" type="button" icon="pi pi-check"
									class="p-button-success" (click)="selecionarAtendente(item)">
								</button>
							</td>
						</tr>
					</ng-template>
				</p-table>
			</p-dialog>
		</div>
	</div>
</div>